export const COMPONENT_DRAG_TYPE = 'application/x-ironman-component'
export const IMAGE_DRAG_TYPE = 'application/x-ironman-image'

// 只重新组织已有组件，不改变旧配置、渲染器或拖放编号。
const sections = [
  { id: 'common', label: '常用', props: ['text', 'datetime', 'swiper', 'iframe', 'img', 'table', 'tabs', 'navigation', 'productList', 'deviceList', 'deviceProperty', 'deviceGroup', 'deviceStatus', 'componentTitle', 'weekSchedule'], expanded: true },
  { id: 'line', label: '折线图', props: ['line'], expanded: false },
  { id: 'media', label: '多媒体', props: ['imgborder', 'video', 'Player'] },
  { id: 'pipe', label: '管线', props: ['StraightLine', 'VerticalLine'] },
  { id: 'shape', label: '形状', props: ['Rectangle', 'Round'] },
  { id: 'bar', label: '柱状图', props: ['bar', 'pictorialbar'] },
  { id: 'progress', label: '进度条', props: ['progress'] },
  { id: 'pie', label: '饼图', props: ['pie'] },
  { id: 'map', label: '地图', props: ['map', 'Dmap'] },
  { id: 'metric', label: '指标', props: ['flop', 'gauge', 'wordcloud'] },
  { id: 'other-chart', label: '其他图表', props: ['common', 'radar', 'scatter', 'funnel'] },
  { id: 'other', label: '其他组件', props: [] }
]

export function componentSections (baseList, query = '') {
  const groups = sections.map(section => ({ ...section, items: [] }))
  const keyword = query.trim().toLowerCase()
  baseList.forEach((group, groupIndex) => group.children.forEach((item, childIndex) => {
    if (!item.label.toLowerCase().includes(keyword)) return
    const section = groups.find(entry => entry.props.includes(item.option.component.prop)) || groups[groups.length - 1]
    section.items.push({ ...item, key: groupIndex + ':' + childIndex })
  }))
  return groups.filter(section => section.items.length)
}

export function resolveComponent (baseList, key) {
  if (!/^\d+:\d+$/.test(key)) return null
  const [group, index] = key.split(':').map(Number)
  return baseList[group] && baseList[group].children[index] || null
}

export function imageComponent (baseList, images, key) {
  const resource = resolveComponent(images.map(children => ({ children })), key)
  const base = baseList.flatMap(group => group.children).find(item => item.option.component.prop === 'img')
  if (!resource || !base) return null
  const option = JSON.parse(JSON.stringify(base.option))
  option.name = resource.label
  option.title = resource.label
  option.data = { value: resource.value }
  return option
}
